import { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppBreadcrumb from '../../components/ui/AppBreadcrumb';
import { setNavigateTo } from '../../redux/actions/ui.actions';
import { FACULTY_CLASSES } from "../../navigation/ROUTE_CONSTANTS";
import { getOneClass } from "../../services/classesService";
import { deleteClass } from '../../redux/actions/classes.actions';

const FacultyClassesDelete = () => {
    const dispatch = useDispatch();

    const { classId } = useParams();
    const [classData, setClassData] = useState({});

    useEffect(() => {
        document.title = process.env.REACT_APP_SITE_TITLE + ' - Delete Class';
    });

    useEffect(() => {
        getOneClass(classId).then((data) => {
            setClassData(data);
        })
    }, [classId]);

    const handleCancel = () => {
        dispatch(setNavigateTo(FACULTY_CLASSES));
    }

    const handleDelete = () => {
        dispatch(deleteClass(classId));
    }

    return (
        <Container className='mb-5 pb-5'>
            <Row>
                <Col>
                    <AppBreadcrumb headText="Delete class" crumbList={[{ linkTo: FACULTY_CLASSES, label: 'Classes' }]} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='vstack col-md-4 mx-auto mt-4 text-center'>
                        <h4 className='pt-2 pb-3 text-center'>Delete class</h4>
                        <h5 className='mt-3 mb-4 pt-2 pb-2'>Are you sure you want to remove this class?</h5>
                        <p>Class: <strong>{classData.name}</strong></p>
                    </div>
                </Col>
            </Row>
            <Row>
                <p className="mt-4 mb-4 text-center">
                    <Button color={'success'} className="me-2" onClick={handleDelete}>
                        Delete class
                    </Button>
                    <Button color={'secondary'} onClick={handleCancel} >
                        Cancel
                    </Button>
                </p>
            </Row>
        </Container>
    )

}

export default FacultyClassesDelete;